import React, { useState } from 'react';
import i18next from 'i18next';
import { InterLang, getCategFromTranslation } from '../../helpers';
import { get } from 'local-storage';
import { useDispatch } from 'react-redux';
import $ from 'jquery';


const LangSwitcher = ({ sub = false, icon = false , dashboard = false}) => {

    const dispatch = useDispatch();

    const [show, setShow] = useState(false);

    const [btnInter, setBtnInter] = React.useState(
        InterLang.find(itm => {
            return itm.code === (
                get('i18nextLng') !== null
                    ? get('i18nextLng')
                    : 'fr'
            )
        })
    );

    const handleLang = lang => {

        if (lang.code !== get('i18nextLng')) {
            $("#moverlay").css('display', 'block');


            setTimeout(() => {
                $("#moverlay").css('display', 'none');

                setBtnInter(lang);
                i18next.changeLanguage(lang.code);

                if (sub) {
                    getCategFromTranslation(lang, dispatch, "ok");
                } else {
                    getCategFromTranslation(lang, dispatch);
                }
            }, 3000);
        }

    };

    return <div className="btn-group">
        {
            icon
                ? <span onClick={() => setShow(!show)} type="button" className={show ? `dropdown-toggle show` : `dropdown-toggle`} id="footerLanguageSelect" data-bs-toggle="dropdown" aria-expanded={show ? 'true' : 'false'} data-bs-dropdown-animation>
                    <i className="bi bi-globe"></i>&nbsp;<span className='text-capitalize ml-2'>{btnInter.code}</span>
                </span>
                : <button onClick={() => setShow(!show)} type="button" className={show ? `btn btn-soft-secondary btn-xs dropdown-toggle show` : `btn btn-soft-secondary btn-xs dropdown-toggle`} id="footerLanguageSelect" data-bs-toggle="dropdown" aria-expanded={show ? 'true' : 'false'} data-bs-dropdown-animation>
                    <span className="d-flex align-items-center">
                        <img className="avatar avatar-xss avatar-circle me-2" src={sub = "market-place" ? `../../${btnInter.flag}` : sub ? `../${btnInter.flag}` : btnInter.flag} alt={btnInter.alt} width="16" />
                        <span>{btnInter.title}</span>
                    </span>
                </button>
        }

        <div className={`dropdown-menu ${show ? 'show' : ''}`} aria-labelledby="footerLanguageSelect">
            {InterLang.map((lang, key) =>
                <span key={key} className="btn dropdown-item d-flex align-items-center" onClick={() => handleLang(lang)}>
                    <img className="avatar avatar-xss avatar-circle me-2" src={sub = "market-place" ? `../../${lang.flag}` : sub ? `../${lang.flag}` : lang.flag} alt={lang.alt} width="16" />
                    <span>{lang.title}</span>
                </span>
            )}
        </div>
    </div>
}

export default LangSwitcher;